(() => {
  function prefillName() {
    const input = document.getElementById('custom-step-process-dogname');
    const url = new URL(window.location.href);
    const name = url.searchParams.get('pa_dog_name')?.trim().slice(0, 100);
    const property = document.getElementById('input-custom-dog-name');
    if (property && url.searchParams.get('pa_funnel') === 'funnel-004-variant') {
      // Clone the existing property to preserve its product-form association.
      let funnel = document.getElementById('input-pa-purchase-funnel');
      if (!funnel) {
        funnel = property.cloneNode(false);
        funnel.id = 'input-pa-purchase-funnel';
        funnel.name = 'properties[_purchase_funnel]';
        property.insertAdjacentElement('afterend', funnel);
      }
      funnel.value = 'funnel-004-variant';
    }
    // Keep pa_funnel in the URL so refreshing the form retains attribution.
    if (!input || !name) return;
    input.value = name;
    if (property) property.value = name;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    url.searchParams.delete('pa_dog_name');
    window.history.replaceState(window.history.state, '', url.href);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefillName);
  else prefillName();
})();
